import {
  SET_REIMBURSEMENTREF,
  SET_COPY_REIMBURSEMENTREF,
  SET_PAYMENT_METHOD,
} from '../../ActionTypes'

export default (state = {}, action = {}) => {
  switch (action.type) {
    case SET_REIMBURSEMENTREF:
      return {
        ...state,
        reimbursementRef: action.reimbursementRef,
      }
    case SET_COPY_REIMBURSEMENTREF:
      return {
        ...state,
        copyReimbursementRef: action.copyReimbursementRef,
      }
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.paymentMethod,
      }
    default:
      return state
  }
}
